export default {
  state: {
    routingModal: {
      show: false,
      validation: {
        show: false,
        title: '',
        message: ''
      },
      ajax: {
        show: false,
        loading: false,
        success: false,
        message: ''
      },
      confirmation: {
        show: false,
        title: '',
        message: '',
        action: null
      }
    }
  },
  mutations: {
    // Modal Container
    showRoutingModal (state) { state.routingModal.show = true },
    hideRoutingModal (state) {
      state.routingModal.show = false
      state.routingModal.validation = {
        show: false,
        title: '',
        message: ''
      }
      state.routingModal.ajax = {
        show: false,
        loading: false,
        success: false,
        message: ''
      }
      state.routingModal.confirmation = {
        show: false,
        title: '',
        message: '',
        action: null
      }
    },

    // ValidationModal
    setRoutingValidationModal (state, value) { state.routingModal.validation = value },

    // Ajax Modal
    setRoutingAjaxModal (state, value) { state.routingModal.ajax = value },

    // Confirmation Modal
    setConfirmationModal (state, value) { state.routingModal.confirmation = value },
    resetConfirmationModal (state) {
      state.routingModal.confirmation = {
        show: false,
        title: '',
        message: '',
        action: null
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/routing/routing-modal.js